import { getPath } from '@/router/common'

const baseUrl = {
  title: '油卡管理',
  path: 'VehicleOilCard'
}

export default [
  {
    path: getPath('OilCardMaterial', baseUrl),
    name: 'OilCardMaterial',
    component: () => import('@/views/vehicleOilCard/oilCardMaterial/index.vue'),
    meta: {
      title: '油卡资料'
    }
  },
  {
    path: getPath('AddEditOilCardMaterial', baseUrl),
    name: 'AddEditOilCardMaterial',
    component: () =>
      import(
        '@/views/vehicleOilCard/oilCardMaterial/addEditOilCardMaterial.vue'
      ),
    meta: {
      title: '油卡新增与编辑'
    }
  },
  {
    path: getPath('ImportCardMaterialMain', baseUrl),
    name: 'ImportCardMaterialMain',
    component: () =>
      import(
        '@/views/vehicleOilCard/oilCardMaterial/importCardMaterialMain.vue'
      ),
    meta: {
      title: '油卡-油卡资料导入'
    }
  },
  {
    path: getPath('ImportWaybillCardMaterial', baseUrl),
    name: 'ImportWaybillCardMaterial',
    component: () =>
      import(
        '@/views/vehicleOilCard/oilCardMaterial/importWaybillCardMaterial.vue'
      ),
    meta: {
      title: '导入油卡资料'
    }
  },
  {
    path: getPath('CardMaterialDetails', baseUrl),
    name: 'CardMaterialDetails',
    component: () =>
      import('@/views/vehicleOilCard/oilCardMaterial/cardMaterialDetails.vue'),
    meta: {
      title: '导入油卡资料明细'
    }
  },
  {
    path: getPath('OilCardReg', baseUrl),
    name: 'OilCardReg',
    component: () => import('@/views/vehicleOilCard/oilCardReg/index.vue'),
    meta: {
      title: '油卡充值'
    }
  },
  {
    path: getPath('AddOilCardReg', baseUrl),
    name: 'AddOilCardReg',
    component: () =>
      import('@/views/vehicleOilCard/oilCardReg/addOilCardReg.vue'),
    meta: {
      title: '新增油卡充值'
    }
  },
  {
    path: getPath('OilCardGive', baseUrl),
    name: 'OilCardGive',
    component: () => import('@/views/vehicleOilCard/oilCardGive/index.vue'),
    meta: {
      title: '油卡分配'
    }
  },
  {
    path: getPath('AddOilCardGive', baseUrl),
    name: 'AddOilCardGive',
    component: () =>
      import('@/views/vehicleOilCard/oilCardGive/addOilCardGive.vue'),
    meta: {
      title: '新增分配'
    }
  },
  {
    path: getPath('OilCardStorage', baseUrl),
    name: 'OilCardStorage',
    component: () => import('@/views/vehicleOilCard/oilCardStorage/index.vue'),
    meta: {
      title: '油卡入库'
    }
  },
  {
    path: getPath('OilCardOutStorage', baseUrl),
    name: 'OilCardOutStorage',
    component: () =>
      import('@/views/vehicleOilCard/oilCardOutStorage/index.vue'),
    meta: {
      title: '油卡出库'
    }
  },
  {
    path: getPath('AddOilCardOutStorage', baseUrl),
    name: 'AddOilCardOutStorage',
    component: () =>
      import(
        '@/views/vehicleOilCard/oilCardOutStorage/addOilCardOutStorage.vue'
      ),
    meta: {
      title: '新增油卡出库'
    }
  },
  {
    path: getPath('OilCardRecycling', baseUrl),
    name: 'OilCardRecycling',
    component: () =>
      import('@/views/vehicleOilCard/oilCardRecycling/index.vue'),
    meta: {
      title: '油卡回收'
    }
  },
  {
    path: getPath('AddOilCardRecycling', baseUrl),
    name: 'AddOilCardRecycling',
    component: () =>
      import('@/views/vehicleOilCard/oilCardRecycling/addOilCardRecycling.vue'),
    meta: {
      title: '新增油卡回收'
    }
  },
  {
    path: getPath('OilCardInfo', baseUrl),
    name: 'OilCardInfo',
    component: () => import('@/views/vehicleOilCard/oilCardInfo/index.vue'),
    meta: {
      title: '油卡统计'
    }
  },
  {
    path: getPath('CardSecond75313', baseUrl),
    name: 'CardSecond75313',
    component: () => import(/* webpackChunkName: "CardSecond75313" */ '@/views/vehicleOilCard/cardSecond75313/index.vue'),
    meta: {
      title: '副卡充值'
    }
  },
  {
    path: getPath('SecondCardAdd75313', baseUrl),
    name: 'SecondCardAdd75313',
    component: () => import(/* webpackChunkName: "SecondCardAdd75313" */ '@/views/vehicleOilCard/secondCardAdd75313/index.vue'),
    meta: {
      title: '新增修改副卡充值'
    }
  },
  {
    path: getPath('OilCarddetail', baseUrl),
    name: 'OilCarddetail',
    component: () => import('@/views/vehicleOilCard/oilCarddetail/index.vue'),
    meta: {
      title: '油卡明细'
    }
  },
  {
    path: getPath('CardMaterialTemplate', baseUrl),
    name: 'CardMaterialTemplate',
    component: () => import(/* webpackChunkName: "CardMaterialTemplate" */ '@/views/vehicleOilCard/cardMaterialTemplate/index.vue'),
    meta: {
      title: '油卡导入模板管理'
    }
  },
  {
    path: getPath('CardMaterialTemplateEdit', baseUrl),
    name: 'CardMaterialTemplateEdit',
    component: () => import(/* webpackChunkName: "CardMaterialTemplateEdit" */ '@/views/vehicleOilCard/cardMaterialTemplateEdit/index.vue'),
    meta: {
      title: '油卡导入模板管理'
    }
  },
  {
    path: getPath('OilcanMaterial', baseUrl),
    name: 'VehicleOilCard_OilcanMaterial',
    component: () => import(/* webpackChunkName: "VehicleOilCard_OilcanMaterial" */ '@/views/vehicleOilCard/oilcanMaterial/index.vue'),
    meta: {
      title: '油罐资料'
    }
  },
  {
    path: getPath('OilcanGive', baseUrl),
    name: 'VehicleOilCard_OilcanGive',
    component: () => import(/* webpackChunkName: "VehicleOilCard_OilcanGive" */ '@/views/vehicleOilCard/oilcanGive/index.vue'),
    meta: {
      title: '油罐入库'
    }
  },
  {
    path: getPath('OilCanOutStorage', baseUrl),
    name: 'VehicleOilCard_OilCanOutStorage',
    component: () => import(/* webpackChunkName: "VehicleOilCard_OilCanOutStorage" */ '@/views/vehicleOilCard/oilCanOutStorage/index.vue'),
    meta: {
      title: '油罐出库'
    }
  },
  {
    path: getPath('OilCanInfo', baseUrl),
    name: 'VehicleOilCard_OilCanInfo',
    component: () => import(/* webpackChunkName: "VehicleOilCard_OilCanInfo" */ '@/views/vehicleOilCard/oilCanInfo/index.vue'),
    meta: {
      title: '油罐统计'
    }
  },
  {
    path: getPath('AddOilcanMaterial', baseUrl),
    name: 'VehicleOilCard_AddOilcanMaterial',
    component: () => import(/* webpackChunkName: "VehicleOilCard_AddOilcanMaterial" */ '@/views/vehicleOilCard/addOilcanMaterial/index.vue'),
    meta: {
      title: '油卡油罐资料'
    }
  },
  {
    path: getPath('AddOilCanGive', baseUrl),
    name: 'VehicleOilCard_AddOilCanGive',
    component: () => import(/* webpackChunkName: "VehicleOilCard_AddOilCanGive" */ '@/views/vehicleOilCard/addOilCanGive/index.vue'),
    meta: {
      title: '油罐入库'
    }
  },
  {
    path: getPath('AddOilCanOut', baseUrl),
    name: 'VehicleOilCard_AddOilCanOut',
    component: () => import(/* webpackChunkName: "VehicleOilCard_AddOilCanOut" */ '@/views/vehicleOilCard/addOilCanOut/index.vue'),
    meta: {
      title: '油罐出库'
    }
  }
]
